import React, { Component } from "react";

class PersonalLoanforTOP extends Component {
  render() {
    return (
      <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <a href="/home" className="a-breadcrumbs">หน้าแรก</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการด้านสินเชื่อ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">เงินกู้สามัญ</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="/personalloanfortop" className="a-breadcrumbs">พนักงานไทยออยล์</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50" style={{width: '100%', fontFamily: '"Cordia New"'}}>
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>พนักงานไทยออยล์</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <p style={{fontSize:'20px'}}><b>เงินกู้สามัญ สมาชิกพนักงานบมจ. ไทยออยล์ และเจ้าหน้าที่สหกรณ์</b></p>
                <p style={{fontSize:'20px'}}><b>เงินกู้สามัญทั่วไป</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th style={{width:'20%'}}>สิทธิตามอายุงาน</th>
                      <th style={{width:'30%'}}>วงเงินกู้สูงสุด(บาท)</th>
                      <th style={{width:'10%'}}>งวดชำระ(ไม่เกิน)</th>
                      <th style={{width:'20%'}}>หลักประกัน</th>
                      <th style={{width:'20%'}}>หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{width: 250}}>
                        <ul className="mb-25">
                          <li>อายุงาน 1 ปี - 4 ปี</li>
                          <li>อายุงานมากกว่า 4 ปี - 5 ปี</li>
                          <li>อายุงานมากกว่า 5 ปี - 8 ปี</li>
                          <li>อายุงานมากกว่า 8 ปี - 10 ปี</li>
                          <li>อายุงานมากกว่า 10 ปีขึ้นไป</li>
                        </ul>
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>วงเงินสูงสุด 250,000 บาท (สองแสนห้าหมื่นบาทถ้วน)</li>
                          <li>วงเงินสูงสุด 500,000 บาท (ห้าแสนบาทถ้วน)</li>
                          <li>วงเงินสูงสุด 750,000 บาท (เจ็ดแสนห้าหมื่นบาทถ้วน)</li>
                          <li>วงเงินสูงสุด 1,000,000 บาท (หนึ่งล้านบาทถ้วน)</li>
                          <li>วงเงินสูงสุด 1,500,000 บาท (หนึ่งล้านห้าแสนบาทถ้วน)</li>
                        </ul>
                      </td>
                      <td>
                        <ul className="mb-25">
                          <li>150</li>
                        </ul>
                      </td>
                      <td>มูลค่าหุ้นและหรือเงินฝากบัญชีของสหกรณ์ออมทรัพย์จำนวน 20 %ของวงเงินกู้ค้ำตลอดสัญญา</td>
                      <td>สมาชิกที่มีอายุตั้งแต่ 51 ปีขึ้นไป ที่ใช้วงเงินกู้สามัญตามสิทธิอายุงาน จะสามารถผ่อนชำระได้ไม่เกินเกษียณอายุ (60 ปี)</td>
                    </tr>
                  </tbody>
                </table>
                <p style={{fontSize:'20px'}}><b>เงินกู้สามัญพิเศษ</b></p>
                <table className="table table-bordered table-striped table-condensed table-hover">
                  <thead>
                    <tr style={{color: '#ffffff', backgroundColor: '#3f5797'}}>
                      <th>วงเงินกู้สูงสุด(บาท)</th>
                      <th>งวดชำระ(ไม่เกิน)</th>
                      <th>หลักประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>100 % ของมูลค่าหุ้น
                      </td>
                      <td>150
                      </td>
                      <td>หุ้นค้ำตามมูลค่าหนี้
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="mb-20" style={{fontSize:'20px'}}>ยื่นคำขอกู้ได้ที่&nbsp;&nbsp;&nbsp;<u><a href="https://savingscoop.thaioilgroup.com/savingscoop/Home/" target="_blank" style={{color: '#4db6f1'}}>ระบบข้อมูลสมาชิกออนไลน์</a></u></p>
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PersonalLoanforTOP;
